var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, values, makeObservable } from 'mobx';
import { computedFn } from 'mobx-utils';
import { MobxPrepone } from '../../../utils/mobx/decorators/MobxPrepone';
import { runtime } from '../../runtime/Runtime';
import { head, uniq } from '../../../utils/helper/lodash_replacements';
import { cachedSet, universalMapValues } from '../../../utils/mobx/utils_mobx';
export class ActorAspects {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    aspectsMapWithoutTraits = observable.map();
    get actor() {
        return this.parent;
    }
    get aspectsWithTraits() {
        return universalMapValues(this.actor.actorStore.aspects);
    }
    get aspectsWithoutTraits() {
        return values(this.aspectsMapWithoutTraits);
    }
    get allAspectsArray() {
        return uniq([...this.aspectsWithTraits, ...this.aspectsWithoutTraits, this.actor.core]); // always instantiate core aspect
    }
    get mainAspect() {
        return this.actor.inner || this.actor.outer || head(this.actor.actorAspects.allAspectsArray);
    }
    ensuredAspectWithinComputed = computedFn(
    // computedFN to avoid rerender on modifyState ??
    (name) => {
        const existingAspect = this.actor.actorStore.aspects.get(name);
        if (existingAspect)
            return existingAspect;
        const existingAspect2 = this.aspectsMapWithoutTraits.get(name);
        if (existingAspect2)
            return existingAspect2;
        return MobxPrepone.provideInstant({
            owner: this,
            instantFactory: () => this.getLazyOrNewAspect(name),
            modifyState: aspect => this.aspectsMapWithoutTraits.set(name, aspect),
            context: name,
            scheduler: runtime.runtimeScheduler.addToNextIdleStateChange,
        });
    });
    getLazyOrNewAspect(name) {
        return runtime.class.Aspect.fromSerialized({
            parent: this.actor,
            constructorArgs: { name },
        });
    }
}
__decorate([
    observable.shallow
], ActorAspects.prototype, "aspectsMapWithoutTraits", void 0);
__decorate([
    cachedSet
], ActorAspects.prototype, "allAspectsArray", null);
__decorate([
    computed
], ActorAspects.prototype, "mainAspect", null);
export const ensuredAspectProxy = {
    get(target, name) {
        return target.actorAspects.ensuredAspectWithinComputed(name);
    },
};
